import { Text } from '@robotrader/design-system';

const NewPairPage = () => <Text.H3 style={{ marginBottom: '1rem' }}>New Pair</Text.H3>;

export default NewPairPage;
